import React from "react";
import styled from "styled-components";
import {Paragraph, Strike} from "../../style/itf-styled-components";
import {DataHeading3} from "./list";
import BuyButton from "../buy-button";

const Container = styled.div``;

const DataSet = styled.div`
  border-bottom: 1px solid ${props => props.theme.text};
  padding-bottom: 25px;
`;

const Data = styled.div`
  display: inline-block;
  width: ${props => ({
    paragraph: "35%",
    strongParagraph: "35%",
    strikeParagraph: "35%",
  }[props.type] || "100%")};
  
  :last-child {
    margin-top: 25px;
  }
`;

const DataParagraph = styled(Paragraph)`
  display: inline-block;
  padding-top: 5px;
  padding-bottom: 5px;
`;

const DataFieldName = styled.div``;
const DataFieldValue = styled.div``;
const DataBuyButton = styled(BuyButton)`
  padding-left: 80px;
  padding-right: 80px;
`;

class MobileList extends React.Component {

  componentDidMount() {
    document.querySelectorAll('.checkOutButton').forEach(button => {
      button.addEventListener('click', function(e) {
        if (typeof window !== "undefined") {
          if (window.fbq != null) {
            window.fbq('track', 'InitiateCheckout');
          }
        }
      }, false)
    })
  }

  render() {
    return (
      <Container className={this.props.className}>
        {this.props.list.data.map((dataSet, index) => (
          <DataSet key={index}>
            {dataSet.map((data, index) => (
              <Data key={index} type={data.type}>

                <DataFieldName>
                  {(this.props.list.head.find(item => item.dataField === data.field) || {}).label}
                </DataFieldName>

                <DataFieldValue>
                  {{
                    heading3: <DataHeading3>{data.value}</DataHeading3>,
                    paragraph: <DataParagraph>{data.value}</DataParagraph>,
                    strongParagraph: <DataParagraph><strong>{data.value}</strong></DataParagraph>,
                    strikeParagraph: <DataParagraph><Strike>{data.value}</Strike></DataParagraph>,
                    buyButton: <DataBuyButton className="checkOutButton" button={data.value}/>,
                  }[data.type]}
                </DataFieldValue>
              </Data>
            ))}
          </DataSet>
        ))}
      </Container>
    );
  }
}

export default MobileList;